<div class="container my-3 p-3 General container-fluid">
  <h3>{{'meetthestaff.Meetthestaff'|translate}}</h3>
  <p>{{'meetthestaff.TheAssessorsOfficev2'|translate}}</p>

  <a class="btn btn-primary" href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1670277167/PA/ASSR_OrgCharts.pdf" target="_blank">
    <span>{{'meetthestaff.ViewChart'|translate}}</span>
  </a>
  <hr>
</div>
